import getConfigEnv from '@brixel-io/brixel-components/dist/configuration/Settings';
import { handleActions } from 'redux-actions';
import { languagesList } from '@brixel-io/brixel-components/dist/configuration/Constants';
import { ERROR_MESSAGE, SET_FEATURE_FLAGS, SET_LANGUAGE, SET_LANGUAGES, SET_NOTIFICATION, SPINNER_OFF, SPINNER_ON, SPINNER_SMALL, SET_WINDOW_DIMENSIONS, } from '../actions/types/CommonTypes';
export const defaultState = {
    configUrl: getConfigEnv,
    errorMsg: {},
    featureFlags: [],
    isLoading: 0,
    isSmallLoading: {},
    languages: getConfigEnv.languages || [],
    language: 'en',
    notification: [],
    requestDone: false,
    windowDimensions: {
        width: typeof window !== 'undefined' ? window.innerWidth : 0,
        height: typeof window !== 'undefined' ? window.innerHeight : 0,
    },
};
const convertLanguage = (lng) => {
    let lang = 'en';
    const checkLangExist = languagesList.find((lg) => lg.code === lng);
    if (checkLangExist)
        lang = lng;
    return lang;
};
export default handleActions({
    [SET_WINDOW_DIMENSIONS]: (state, action) => ({
        ...state,
        windowDimensions: action.payload,
    }),
    [SPINNER_ON]: (state) => ({
        ...state,
        isLoading: state.isLoading + 1,
    }),
    [SPINNER_OFF]: (state) => ({
        ...state,
        isLoading: state.isLoading - 1,
    }),
    [ERROR_MESSAGE]: (state, action) => ({
        ...state,
        errorMsg: action.payload,
    }),
    [SET_LANGUAGES]: (state, action) => ({
        ...state,
        languages: action.payload,
    }),
    [SET_LANGUAGE]: (state, action) => ({
        ...state,
        language: convertLanguage(action.payload),
    }),
    [SET_NOTIFICATION]: (state, action) => ({
        ...state,
        notification: action.payload,
    }),
    [SPINNER_SMALL]: (state, action) => ({
        ...state,
        isSmallLoading: {
            ...state.isSmallLoading,
            ...action.payload,
        },
    }),
    [SET_FEATURE_FLAGS]: (state, action) => ({
        ...state,
        featureFlags: action.payload,
    }),
}, defaultState);
